const REACT_APP_API_ENDPOINT = `${process.env.REACT_APP_SBMA_APPOINTMENT_API_ENDPOINT}/api/v1`;
const BOOKING_API_ENDPOINT = REACT_APP_API_ENDPOINT + "/booking";


export default {
    GET_LIST_BOOKING:                                  BOOKING_API_ENDPOINT + "/list",
    CREATE_BOOKING:                                    BOOKING_API_ENDPOINT + "/create",
    VIEW_BOOKING:                                      BOOKING_API_ENDPOINT + "/view",
    UPDATE_BOOKING:                                    BOOKING_API_ENDPOINT + "/update",
    UPDATE_BOOKING_STATUS:                             BOOKING_API_ENDPOINT + "/update/status",
    FILTER_BOOKING:                                    BOOKING_API_ENDPOINT + "/filter",

    // common
    GET_BOOKING_TYPES:                                 BOOKING_API_ENDPOINT + "/types",
    GET_BOOKING_STATUS_LIST:                           BOOKING_API_ENDPOINT + "/status",
} 